import { BaseTooltip } from './base';
export { InfoIcon, WarningIcon } from './TooltipIcons';

/**
 * Tooltip - Shows info text on hover
 *
 * Public compatibility wrapper around the internal Base UI tooltip layer.
 *
 * @param {React.ReactNode} text - Primary tooltip content
 * @param {React.ReactNode} content - Backward-compatible alias for tooltip content
 * @param {string} position - 'top', 'right', 'bottom', 'left', or 'auto' (default)
 * @param {number} delay - Delay in ms before showing (default: 500)
 * @param {boolean} interactive - If true, tooltip stays open when hovering over it
 * @param {boolean} disabled - If true, prevents opening and closes any open tooltip
 */
const Tooltip = ({
  text,
  content,
  children,
  position = 'auto',
  delay = 500,
  defaultOpen = false,
  interactive = false,
  disabled = false,
}) => {
  const resolvedContent = content ?? text;

  if (resolvedContent == null || resolvedContent === false || resolvedContent === '') {
    return children;
  }

  return (
    <BaseTooltip
      content={resolvedContent}
      position={position}
      delay={delay}
      defaultOpen={defaultOpen}
      interactive={interactive}
      disabled={disabled}
    >
      {children}
    </BaseTooltip>
  );
};

export default Tooltip;
